export const DEFAULT_HEADER_VALUES = ['Teste', 'Resultado Bruto', 'Classificação'];

export const DEFAULT_COLUMN_WIDTHS = [200, 100, 100];
